// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"WizardSidebarButtons_buttonContainer__1753x","actionButtons":"WizardSidebarButtons_actionButtons__31hSr"};